import { OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ShoppingService } from "../../shared/services/shopping.service";
import { AlertService } from 'app/shared/services/alert.service';
var ShopItemsComponent = /** @class */ (function () {
    function ShopItemsComponent(shopping, alertService, router, route) {
        this.shopping = shopping;
        this.alertService = alertService;
        this.router = router;
        this.route = route;
        this._hasLoadedShop = false;
    }
    ShopItemsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.shopping.getAvailableItems().then(function (items) {
            _this._groupItems = items.filter(function (i) { return i.subItems && i.subItems.length; });
            _this._items = items.filter(function (i) { return !(i.subItems && i.subItems.length); });
            _this._hasLoadedShop = true;
        });
    };
    Object.defineProperty(ShopItemsComponent.prototype, "hasLoadedShop", {
        get: function () {
            return this._hasLoadedShop;
        },
        enumerable: true,
        configurable: true
    });
    ShopItemsComponent.prototype.addItemsToCart = function () {
        var _this = this;
        var totalitems = this.getItemsForCheckout();
        // return a resolved promise since there's nothing to do here.
        if (!totalitems.length) {
            return Promise.resolve();
        }
        var totalQuantity = totalitems.map(function (i) { return i.quantity; }).reduce(function (pv, cv) { return pv + cv; }, 0);
        this.addItems(totalitems)
            .then(function () {
            var message = totalQuantity + " items were added to your cart";
            _this.alertService.success(message);
        })
            .catch(function (error) {
            console.error(error);
            _this.alertService.error("There was a problem in adding the items you selected to the cart.  Please try again.");
        });
    };
    ShopItemsComponent.prototype.checkout = function () {
        var _this = this;
        var items = this.getItemsForCheckout();
        if (!(items.length || this.hasItems)) {
            this.alertService.error("Please select the number of items you wish to purchase before checking out.");
            return;
        }
        this.addItems(items)
            .then(function () {
            return _this.router.navigate(["checkout"], { relativeTo: _this.route });
        })
            .catch(function (error) {
            console.error(error);
            _this.alertService.error("There was a problem in checking out your items, please try again or contact customer support.");
        });
    };
    ShopItemsComponent.prototype.addItems = function (items) {
        var _this = this;
        return Promise.all(items.map(function (i) { return _this.shopping.addItemToCart(i); }))
            .then(function (results) {
            items.forEach(function (i) { return i.quantity = 0; });
        });
    };
    ShopItemsComponent.prototype.getItemsForCheckout = function () {
        var groupItems = this._groupItems.filter(function (gi) { return gi.quantity > 0; });
        var items = this._items.filter(function (i) { return i.quantity > 0; });
        var totalItems = groupItems.concat(items);
        return totalItems;
    };
    Object.defineProperty(ShopItemsComponent.prototype, "hasItems", {
        get: function () {
            return this.shopping.hasItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShopItemsComponent.prototype, "groupItems", {
        get: function () {
            return this._groupItems;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ShopItemsComponent.prototype, "items", {
        get: function () {
            return this._items;
        },
        enumerable: true,
        configurable: true
    });
    return ShopItemsComponent;
}());
export { ShopItemsComponent };



// WEBPACK FOOTER //
// ./src/app/admin/shop-items/shop-items.component.ts.pre-build-optimizer.js